module.exports = __webpack_public_path__ + "img/restaurant-3.21828b3b.jpg";